export const SEARCH = 'SEARCH';
export const SEARCH_STARTING = 'SEARCH_STARTING';
export const SEARCH_FAILED = 'SEARCH_FAILED';
export const SEARCH_COUNT_ONLY = 'SEARCH_COUNT_ONLY';

export const LOAD_MORE = 'LOAD_MORE';
export const MODIFY_PARAMS = 'MODIFY_PARAMS';
export const FILTER = 'FILTER';

export const FAKE_RESEND = 'FAKE_RESEND';
export const CLEAR_STORES = 'CLEAR_STORES';

export const SEND_INVITATION_PF = 'SEND_INVITATION_PF';
export const RESEND_INVITATION_PF = 'RESEND_INVITATION_PF';
export const IGNORE_CONNECTION_PF = 'IGNORE_CONNECTION_PF';
export const ACCEPT_CONNECTION_PF = 'ACCEPT_CONNECTION_PF';
export const FLIP_LOADER_STATUS = 'FLIP_LOADER_STATUS';
export const ADD_SEARCH_COUNT = 'ADD_SEARCH_COUNT';
export const UPDATE_SEARCH_COUNT_DB = 'UPDATE_SEARCH_COUNT_DB';

export const OPEN_PF_CUSTOM_MSG_POPOVER = 'OPEN_PF_CUSTOM_MSG_POPOVER';
export const CLOSE_PF_CUSTOM_MSG_POPOVER = 'CLOSE_PF_CUSTOM_MSG_POPOVER';
export const UPDATE_CUSTOM_MSG = 'UPDATE_CUSTOM_MSG_IN_PARTNER_FINDER';

export const GETTING_RESPONSE_TIME = 'GETTING_RESPONSE_TIME';
export const GOT_RESPONSE_TIME = 'GOT_RESPONSE_TIME';

// FOR ADDING MM TO PF
// export const GETTING_MARKETING_MATERIALS = 'GETTING_MARKETING_MATERIALS';
// export const GOT_MARKETING_MATERIALS = 'GOT_MARKETING_MATERIALS';



// WEBPACK FOOTER //
// ./src/app/stores/partner-finder/partnerFinder-constants.js